import { FunctionComponent } from "react";
import {
  ButtonsGroupChoiceField,
  PrimaryButton,
  Stack,
  useFormContext,
  useFieldContext,
  FieldSpy
} from "@bps/fluent-ui";
import { FormTenantPromotionCodeSelect } from "@components/form/fields/FormTenantPromotionCodeSelect";
import { useParams } from "react-router-dom";
import { AddCouponFormDialogProps } from "./AddCouponFormDialog.types";

const options = [
  { key: true, text: "Yes" },
  { key: false, text: "No" }
];

interface AddCouponFormFieldsProps
  extends Omit<AddCouponFormDialogProps, "onDismiss" | "onConfirm"> {
  onConfirm: (coupons: string[]) => void;
}

export const AddCouponFormFields: FunctionComponent<AddCouponFormFieldsProps> = ({
  excludePromotionCodeList,
  onConfirm
}) => {
  const { tenantId } = useParams<{ tenantId: string }>();
  const { value: coupons } = useFieldContext<string[]>("coupons");
  const {
    state: { dirty, invalid }
  } = useFormContext();

  return (
    <Stack tokens={{ childrenGap: 16 }}>
      <ButtonsGroupChoiceField
        name="isNeedToApply"
        label="Does a discount need to be applied to this purchase?"
        required
        notUnselectable
        options={options}
      />
      <FieldSpy<boolean> name="isNeedToApply">
        {isNeedToApply => (
          <FormTenantPromotionCodeSelect
            label="Promotion codes"
            disabled={!isNeedToApply}
            required={!!isNeedToApply}
            name="coupons"
            tenantId={tenantId!}
            excludes={excludePromotionCodeList}
          />
        )}
      </FieldSpy>

      <PrimaryButton
        styles={{ root: { width: "fit-content", alignSelf: "end" } }}
        disabled={!dirty}
        onClick={async () => {
          if (!invalid) {
            onConfirm(coupons ?? []);
          }
        }}
      >
        Save
      </PrimaryButton>
    </Stack>
  );
};
